import { Component, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-meta-msg-template-meta-list-modal',
  templateUrl: './msg-template-list-modal.component.html',
  styleUrls: ['./msg-template-list-modal.component.css']
})
export class MetaMsgTemplateMetaListModalComponent {
  @ViewChild('modal') modal: ModalDirective;

  templates: any[] = [];

  show(templates: any[]) {
    this.templates = templates || [];
    this.modal.show();
  }

  close() {
    this.modal.hide();
  }

  getHeader(template: any): any {
    return this.getComponent(template, 'HEADER');
  }

  getBody(template: any): any {
    return this.getComponent(template, 'BODY');
  }

  getFooter(template: any): any {
    return this.getComponent(template, 'FOOTER');
  }

  getButtons(template: any): any[] {
    const component = this.getComponent(template, 'BUTTONS');
    return component?.buttons || [];
  }

  getQualityScore(template: any): string {
    const qualityScore = template?.qualityScore || template?.quality_score;

    if (!qualityScore) {
      return '-';
    }

    if (qualityScore.score) {
      return qualityScore.score;
    }

    return qualityScore.toString();
  }

  private getComponent(template: any, type: string): any {
    return (template?.components || []).find((component: any) =>
      (component.type || '').toUpperCase() === type);
  }
}
